import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitobanglorecab() {



const cardData = {
  keyword: "Mumbai to Bangalore Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Bangalore Cab for travelers seeking a smooth and convenient journey from Maharashtra to Gujarat. Whether you are planning a business trip, family visit, weekend getaway, or group travel, our cab service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Vapi cab services.",

topPlaces: [
  {
    title: "GIDC Garden",
    description:
      "GIDC Garden in Vapi is a peaceful green space ideal for morning walks, photography, and relaxation. Visitors can enjoy landscaped gardens, seating areas, and tranquil surroundings. Traveling by cab ensures a comfortable journey from Mumbai and allows ample time to unwind and explore this local attraction."
  },
  {
    title: "Parnera Fort",
    description:
      "Parnera Fort, located near Vapi, is a historic fort offering panoramic views of the surrounding hills and valleys. Visitors can explore ancient architecture, trekking paths, and scenic viewpoints. A cab ride provides convenient access, making it easier to integrate the fort visit into a full day of sightseeing."
  },
  {
    title: "Daman Ganga Tourist Complex",
    description:
      "This tourist complex near Vapi features gardens, river views, and recreational facilities. Visitors can enjoy family outings, photography, and peaceful walks. Traveling by cab ensures hassle-free access, allowing tourists to combine natural beauty with local sightseeing comfortably."
  },
  {
    title: "Tithal Beach",
    description:
      "Tithal Beach, a short drive from Vapi, is known for its black sand, calm waves, and serene environment. Visitors can enjoy leisurely walks, local snacks, photography, and sunset views. A cab service ensures easy transport, allowing visitors to spend quality time at the beach without worrying about local commuting."
  },
  {
    title: "Jampore Beach",
    description:
      "Jampore Beach, located near Vapi in Daman, offers scenic coastline, water activities, and a relaxed atmosphere. Visitors can engage in photography, beach sports, and picnics. Traveling by cab provides convenient access, making it easy to plan multiple nearby sightseeing spots in one trip."
  },
  {
    title: "Moti Daman Fort",
    description:
      "Moti Daman Fort is a historic landmark with bastions, churches, and museums showcasing Portuguese heritage. Visitors can explore architecture, capture photographs, and enjoy the serene surroundings. A cab ride ensures comfortable travel from Mumbai, enabling a full day of sightseeing."
  },
  {
    title: "St. Jerome Fort",
    description:
      "St. Jerome Fort is another historical attraction near Vapi with scenic views and rich heritage. Visitors can explore fort structures, take photographs, and enjoy peaceful walks. Traveling by cab ensures hassle-free transport, allowing tourists to include multiple heritage sites in their itinerary."
  },
  {
    title: "Daman Market",
    description:
      "Daman Market is vibrant with local handicrafts, souvenirs, and regional snacks. Visitors can shop, explore culture, and enjoy street food delicacies. A cab ride provides convenient transport, allowing travelers to combine shopping with sightseeing efficiently."
  },
  {
    title: "Gopika Temple",
    description:
      "Gopika Temple near Vapi is a spiritual site attracting devotees and visitors interested in cultural exploration. Travelers can perform rituals, enjoy peaceful surroundings, and capture photographs. Traveling by cab ensures easy access and comfortable transport for a spiritual experience."
  },
  {
    title: "Local Parks & Recreation Areas",
    description:
      "Vapi has several parks and recreation areas suitable for family outings, photography, and relaxation. Visitors can enjoy open spaces and leisure activities. A cab service provides hassle-free travel from Mumbai, enabling tourists to cover multiple attractions efficiently."
  }
],




services: [
{
name: "Mumbai to Bangalore Cab",
description: "Mumbai to Bangalore cab service offers comfortable and reliable long-distance transportation between Maharashtra and Karnataka. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys across interstate routes. Professional drivers ensure safe driving and punctual arrival at your destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for corporate travelers, family trips, and relocation travel. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Bangalore Taxi",
description: "Mumbai to Bangalore taxi service provides dependable road transportation for travelers planning interstate journeys. Comfortable AC vehicles ensure pleasant long-distance travel across major national highways. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, corporate visits, and family trips. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure schedules allow passengers to plan trips conveniently. Reliable taxi services ensure smooth and safe travel."
},
{
name: "Mumbai to Bangalore Cab Service",
description: "Mumbai to Bangalore cab service offers reliable intercity transportation for passengers traveling between two major metropolitan cities. Our well-maintained AC vehicles ensure comfortable highway journeys across long distances. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from residential areas, offices, hotels, and airport terminals across Mumbai. Ideal for corporate travel, business meetings, and family journeys. Spacious interiors provide comfortable seating during extended travel hours. Flexible booking options allow travelers to schedule trips easily. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai to Bangalore Taxi Service",
description: "Mumbai to Bangalore taxi service offers efficient and comfortable road travel for long-distance passengers. Our fleet includes AC sedans and SUVs suitable for interstate highway journeys. Skilled drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, tourism, and relocation trips. Spacious seating ensures comfort throughout the journey. Flexible travel schedules allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Bangalore",
description: "Cab from Mumbai to Bangalore offers private and comfortable transportation for passengers traveling long distances. Our AC vehicles ensure smooth highway travel and relaxed journeys throughout the trip. Professional drivers ensure safe driving and reliable service during interstate travel. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, corporate travelers, and business professionals. Spacious interiors ensure comfortable seating for extended journeys. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Bangalore",
description: "Taxi from Mumbai to Bangalore provides dependable road travel for passengers visiting the technology hub of India. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, families, and tourists. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy travel planning. Professional taxi services ensure reliable intercity transportation."
},
{
name: "Mumbai to Bangalore Cab Booking",
description: "Mumbai to Bangalore cab booking allows passengers to reserve vehicles easily for long-distance interstate travel. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips, relocation travel, and family visits. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Bangalore Taxi Booking Online",
description: "Mumbai to Bangalore taxi booking online provides quick and convenient reservations for passengers planning interstate travel. Instant booking confirmation helps travelers schedule trips without delays. Comfortable AC vehicles ensure relaxed highway travel conditions. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Bangalore Cab Price",
description: "Mumbai to Bangalore cab price offers transparent and affordable travel options for passengers planning long-distance journeys. Clear pricing details allow travelers to understand total trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway driving and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Bangalore Taxi Fare",
description: "Mumbai to Bangalore taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth interstate highway travel between the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips and family travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Bangalore One Way Cab",
description: "Mumbai to Bangalore one way cab service is ideal for travelers who require drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance interstate journeys. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, relocation trips, and personal journeys. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Bangalore Round Trip Taxi",
description: "Mumbai to Bangalore round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return schedules allow travelers to complete meetings or personal work comfortably. Comfortable AC vehicles ensure relaxed travel throughout the journey. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for corporate travel and extended family visits. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
}
],

tableData: [
["Mumbai to Bangalore Cab","Mumbai to Bangalore Taxi"],
["Mumbai to Bangalore Cab Service","Mumbai to Bangalore Taxi Service"],
["Cab from Mumbai to Bangalore","Taxi from Mumbai to Bangalore"],
["Mumbai to Bangalore Cab Booking","Mumbai to Bangalore Taxi Booking Online"],
["Mumbai to Bangalore Cab Price","Mumbai to Bangalore Taxi Fare"],
["Mumbai to Bangalore One Way Cab","Mumbai to Bangalore Round Trip Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling long-distance routes like Mumbai to Bangalore. They are familiar with highways, state border routes, and rest stops, ensuring a safe and smooth journey across Maharashtra and Karnataka."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Bangalore cab bookings. We clearly explain per-kilometer charges, toll costs, and driver allowances before booking so travelers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to start your journey early morning or travel overnight, Omshree Cabs offers 24/7 cab booking and customer support for Mumbai to Bangalore trips."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are cleaned and sanitized regularly to provide a comfortable experience during long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way cab services, round trips, and multi-day travel plans so travelers can customize their journey between Mumbai and Bangalore."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for families, corporate travelers, and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your journey to Bangalore begins comfortably without any hassle."
  },
  {
    WhyChooseheading: "Reliable Intercity Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for long-distance cab journeys. Our punctual service, professional drivers, and comfortable vehicles ensure a reliable travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Bangalore by cab?", answer: "The distance from Mumbai to Bangalore is approximately 980 km and the journey usually takes around 16–18 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Bangalore cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Bangalore." },
  { question: "Which vehicles are available for Mumbai to Bangalore travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Bangalore cab bookings." },
  { question: "Can we stop during the journey for rest or meals?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide overnight travel services?", answer: "Yes, many travelers prefer overnight cab travel and our experienced drivers ensure safe night driving." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended for long-distance trips like Mumbai to Bangalore to ensure vehicle availability." },
  { question: "Do you provide corporate travel services to Bangalore?", answer: "Yes, Omshree Cabs provides corporate and business cab services from Mumbai to Bangalore." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Bangalore trip. The driver was very professional and the vehicle was extremely comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Reddy",
    feedback:
      "Our family journey from Mumbai to Bangalore with Omshree Cabs was smooth and safe. The car was clean and the driver handled the long route perfectly.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "description": "Book Mumbai to Bangalore Cab with Omshree Cab for safe and comfortable outstation travel. Reliable taxi service from Mumbai to Bangalore with options for one-way or round trips. Affordable fares, easy online cab booking, and trusted cab service for your Bangalore journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2600"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Bangalore Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Bangalore Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Bangalore with one-way and round trip options. Affordable fares and easy online cab booking for your Bangalore trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobanglorecab;